import React, { Component } from 'react';
import { connect }          from 'react-redux';
import Avata_m              from '../../../container/render_avatar_m';
import { ActionModal }      from '../../../actions/scopoAction';

class batalha_convidar extends Component {

    render() {
       
        return (
            <div className="battle-versus battle-versus-main">
                            <div className="battle-versus-match">
                                {/* <div className="battle-versus-match-player">
                                    <div className="battle-versus-player-avatar">
                                        <Avata_m Foto={this.props.session.foto}/>
                                    </div>
                                </div> */}
                                <div className="battle-versus-match-x">
                                    <a href={void(0)} onClick={()=>this.props.ActionModal(true)} className="battle-versus-x-button">Convidar</a>
                                </div>
                                {/* <div className="battle-versus-match-player">
                                    <div className="battle-versus-player-avatar battle-versus-player-avatar-none">
                                        <a href={void(0)} className="battle-versus-player-avatar-label">
                                            <span className="battle-versus-player-avatar-label-content">Selecionar oponente</span>
                                        </a> */}
                                        {/* <div className="battle-versus-player-avatar-placeholder">&plus;</div> */}
                                        {/* <Avata_m Foto={this.props.session.foto}/>
                                    </div>
                                </div> */}
                            </div>
                    </div>
        );
    }
}

function mapStateToProps(state) {

    return { 
            session : state.auth.session,
            menu    : state.configReducer.menu,
           }
}

export default connect(mapStateToProps,{ActionModal})(batalha_convidar);



// WEBPACK FOOTER //
// ./src/components/aluno/batalha/batalha_convidar.js